import { cookieMutators } from "../mutators/cookie.js";
import { environmentMutators } from "../mutators/environment.js";
import { getDocument } from "../mutators/helpers.js";
import { requestMutators } from "../mutators/request.js";
import { requestExampleMutators } from "../mutators/request-example.js";
import { securitySchemeMutators } from "../mutators/security-schemes.js";
import { serverMutators } from "../mutators/server.js";
function generateClientMutators(store) {
  const documentMutators = (documentName) => {
    const document = getDocument(store, documentName);
    if (document) {
      if (!document.servers) {
        document.servers = [];
      }
      if (!document.components) {
        document.components = {};
      }
      if (!document.components.securitySchemes) {
        document.components.securitySchemes = {};
      }
    }
    return {
      requestExampleMutators: requestExampleMutators(document),
      requestMutators: requestMutators(document),
      securitySchemeMutators: securitySchemeMutators(document?.components?.securitySchemes),
      environmentMutators: environmentMutators(document),
      cookieMutators: cookieMutators(document),
      serverMutators: serverMutators(document?.servers)
    };
  };
  const workspaceMutators = () => {
    const workspace = store.workspace;
    if (!workspace["x-scalar-client-config-servers"]) {
      workspace["x-scalar-client-config-servers"] = [];
    }
    if (!store.workspace["x-scalar-client-config-security-schemes"]) {
      store.workspace["x-scalar-client-config-security-schemes"] = {};
    }
    return {
      environmentMutators: environmentMutators(store.workspace),
      cookieMutators: cookieMutators(store.workspace),
      serverMutators: serverMutators(store.workspace["x-scalar-client-config-servers"]),
      securitySchemeMutators: securitySchemeMutators(store.workspace["x-scalar-client-config-security-schemes"])
    };
  };
  return {
    /**
     * Returns mutators for the workspace-level configuration.
     */
    workspace: () => workspaceMutators(),
    /**
     * Returns mutators for the currently active document.
     * Falls back to the first document if no active document is set.
     */
    active: () => documentMutators(store.workspace["x-scalar-active-document"] ?? Object.keys(store.workspace.documents)[0] ?? ""),
    /**
     * Returns mutators for a specific document by name.
     *
     * @param name - The name of the document
     */
    doc: (name) => documentMutators(name)
  };
}
export {
  generateClientMutators
};
//# sourceMappingURL=index.js.map
